<template>
    <div class="hp-10 flex-column fs-3 jc-center ai-center">
        <i class="icon-email-statut-valid success-50"></i>
        <p class="bold mb-5 fs-4">{{ confirmationLabel }}</p>
        <router-link
            v-if="getIsMultiple"
            :to="{ name: 'supplier' }"
            class="semibold mb-5 hover-primary-50-bkg hover-white primary-50-bkg-hover white-bkg br b-1-primary px-3 py-2"
            >{{ btnLabel }}</router-link
        >
        <a
            v-else
            :href="`/?_f=purchases_purInvoiceOverview&id=${getLinkedid}`"
            class="semibold mb-5 hover-primary-50-bkg hover-white primary-50-bkg-hover white-bkg br b-1-primary px-3 py-2"
            >{{ btnLabel }}</a
        >
        <a :href="`/ocr/list/${getLinkedtype}`" class="semibold">
            {{ $l10n.__('Retourner sur l’import de facture') }}
        </a>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: ocrGetters } = createNamespacedHelpers('ocr');

export default {
    computed: {
        ...ocrGetters(['getLinkedtype', 'getLinkedid', 'getIsMultiple']),
        confirmationLabel() {
            return this.getIsMultiple
                ? this.$l10n.__('Vous avez correctement vérifié vos documents')
                : this.$l10n.__('Vous avez correctement vérifié votre document');
        },
        btnLabel() {
            return this.getIsMultiple
                ? this.$l10n.__('Les retrouver sur la liste des factures fournisseurs')
                : this.$l10n.__('Consulter la facture fournisseur');
        },
    },
    created() {
        if (_.isNil(this.getLinkedtype)) {
            this.$router.push({ name: 'error.not.found' });
        }
    },
};
</script>

<style lang="scss" scoped>
i {
    font-size: 80px;
}
</style>
